import {Outlet} from "react-router";
import OrdibeheshtHeader from "../../Header/Header";
import {useEffect, useState} from "react";
import axios from "axios";
import {prefixUrl} from "../../../Utils/utilsData";
import {toast} from "react-toastify";
import UseShowShopWidget from "../../../hooks/ShowShopWidget";
import NewFooter from "../../Footer/NewFooter";

const MainPage = () => {

  const [footer, setFooter] = useState({});
  const {setShowShopWidget} = UseShowShopWidget();

  useEffect(() => {
    axios
      .get(`${prefixUrl()}/footer.php`)
      .then((res) => {
        if (res.data.status) {
          setFooter(res.data.data);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return (
    <main className="App">
      <OrdibeheshtHeader/>
      <div onClick={() => setShowShopWidget(false)}>
        <Outlet/>
      </div>

      {Object.keys(footer).length > 0 && <NewFooter footerData={footer}/>}
    </main>
  );
};

export default MainPage;
